import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/providers/AppProviders';
import { router } from './app/router';
import { SessionBootstrap } from './app/SessionBootstrap';
import { createAuthStore, identityKey } from './shared/auth';
import './shared/i18n'; // Side-effect: init i18next with DE+EN locales

import './styles/adminFonts';

import './styles/globals.css';

// Privilege-Claims können sich beim Cookie-Refresh ändern. Die Router-Guards müssen dann sofort
// erneut laufen, damit ein entzogener Surface nicht bis zur nächsten Navigation gemountet bleibt.
// Ein Wechsel in einen anderen Workspace oder zu einem anderen Benutzer beginnt auf dessen
// Startseite: die Adresse von vorher gehört zum vorigen Kontext.
createAuthStore().subscribe((state, previous) => {
  if (state.user === previous.user) return;
  const [before, after] = [identityKey(previous.user), identityKey(state.user)];
  if (before && after && before !== after) void router.navigate({ to: '/', replace: true });
  else void router.invalidate();
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error("Root element '#root' not found in index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <AppProviders>
      <SessionBootstrap>
        <RouterProvider router={router} />
      </SessionBootstrap>
    </AppProviders>
  </StrictMode>,
);
